<!-- <ng-template
    [ngIf]="loading()"
    [ngIfElse]="loadData">
    <st-loader
        class="st-cast-list-loader"
        [diameter]="200"
        [productLabel]="languageSettings.PSTWebLoadingLabel"
        [strokeWidth]="10" />
</ng-template>
<ng-template #loadData>
    <mat-toolbar class="st-cast-list-second-top-bar">
        <mat-toolbar-row class="st-cast-list-second-top-bar-row">
            <div class="st-cast-list-second-top-bar-main-cta">
                <mat-label class="st-cast-list-label-channel">{{ channel?.Title }}{{ editionName ? ':' + editionName : '' }} </mat-label>
                <mat-label class="st-cast-list-label-published">{{ publicationStatusLabel }} </mat-label>
            </div>
            <div class="st-cast-list-second-top-bar-right-slot">
                <st-list-drop-down
                    labelPosition="before"
                    [label]="languageSettings.PSTWebRevisionsLabel"
                    [value]="publicationRevisionNumber$ | ngrxPush"
                    [list]="publicationRevisionsList$ | ngrxPush"
                    (valueOutput)="updateRevisionNumber($event)" />
                <ng-template
                    [ngIf]="isReadonly && !inEditMode"
                    [ngIfElse]="publishButton">
                    <button
                        type="button"
                        class="st-cast-list-button st-cast-list-top-bar-right-slot-button-light"
                        [disabled]="disabledCreateNewRevisionButton$ | ngrxPush"
                        [class.st-cast-list-button-disabled]="disabledCreateNewRevisionButton$ | ngrxPush"
                        (click)="newRevision()">
                        {{ languageSettings.PSTWebCreateNewRevisionLabel }}
                    </button>
                </ng-template>
                <button
                    type="button"
                    class="st-cast-list-button st-cast-list-button-right-slot-transparent"
                    [disabled]="disabledPublishButton"
                    [class.st-cast-list-button-disabled]="disabledPublishButton"
                    (click)="removeAll()">
                    {{ languageSettings.PSTWebClearAllItemsLabel }}
                </button>
                <ng-template #publishButton>
                    <button
                        type="button"
                        class="st-cast-list-button st-cast-list-button-right-slot-light"
                        [class.st-cast-list-button-disabled]="disabledPublishButton"
                        [disabled]="disabledPublishButton"
                        (click)="publish()">
                        {{ languageSettings.PSTWebPublishLabel }}
                    </button>
                </ng-template>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    <st-accordion
        class="st-cast-list-accordion"
        cdkDropListGroup>
        <cdk-virtual-scroll-viewport
            id="publication-list-sections"
            class="st-cast-list-view-port"
            st-different-sizes
            cdkScrollable
            cdkDropList
            sortingDisabled
            [itemHeights]="itemHeights$ | ngrxPush"
            [appendOnly]="castService.appendOnly"
            (cdkDropListDropped)="onPublicationListSectionsDrop()">
            <ng-container *cdkVirtualFor="let node of dataSource; let isLast = last; let idx = index; trackBy: trackByGuid">
                <ng-container [ngSwitch]="node?.level">
                    <ng-template [ngSwitchCase]="0">
                        <st-expansion-panel
                            cdkDrag
                            cdkDragDisabled
                            class="st-cast-list-accordion-pane-container"
                            [dragEnabled]="true"
                            [dragStarted]="castService.dragStarted"
                            [guid]="'section|' + node?.id"
                            [expanded]="treeControl.isExpanded(node)"
                            [inEditMode]="isSectionInEditMode(node?.id)"
                            (dragEnterEmitter)="onDragEnter($event)"
                            (panelStateChanged)="onPanelStateChange($event, node)">
                            <ng-container title>
                                <st-text-field
                                    *ngIf="isSectionInEditMode(node?.id); else label"
                                    class="st-cast-list-accordion-pane-container-section"
                                    st-click-stop-propagation
                                    [value]="node?.label"
                                    (changed)="onSectionNameChanged($event, node?.id)"
                                    (keydown.Space)="$event.stopPropagation()"
                                    (keydown.Backspace)="$event.stopPropagation()" />
                                <ng-template #label>
                                    <span class="st-cast-list-accordion-pane-container-label">{{ node?.label }}</span>
                                </ng-template>
                            </ng-container>
                            <ng-container
                                actions
                                class="st-cast-list-accordion-pane-container-actions"
                                st-click-stop-propagation>
                                <span class="st-cast-list-accordion-pane-container-count"> {{ node?.itemsCount }} {{ publicationItemsLabel }} </span>
                                <button
                                    *ngIf="!isSectionInEditMode(node?.id)"
                                    mat-icon-button
                                    class="st-cast-list-accordion-pane-container-first"
                                    st-click-stop-propagation
                                    [disabled]="isReadonly"
                                    (click)="addSection($event, node?.index)">
                                    <mat-icon fontSet="material-symbols-outlined"> add </mat-icon>
                                </button>
                                <button
                                    *ngIf="!isSectionInEditMode(node?.id)"
                                    mat-icon-button
                                    class="st-cast-list-accordion-pane-container-action"
                                    st-click-stop-propagation
                                    [disabled]="isReadonly"
                                    (click)="editSection($event, node?.id)">
                                    <mat-icon fontSet="material-symbols-outlined"> edit </mat-icon>
                                </button>
                                <button
                                    *ngIf="isSectionInEditMode(node?.id)"
                                    mat-icon-button
                                    class="st-cast-list-accordion-pane-container-first"
                                    st-click-stop-propagation
                                    [disabled]="isReadonly"
                                    (click)="saveEditSection($event, node?.id)">
                                    <mat-icon fontSet="material-symbols-outlined"> save </mat-icon>
                                </button>

                                <button
                                    *ngIf="isSectionInEditMode(node?.id)"
                                    mat-icon-button
                                    class="st-cast-list-accordion-pane-container-action"
                                    st-click-stop-propagation
                                    [disabled]="isReadonly"
                                    (click)="cancelEditSection($event, node?.id)">
                                    <mat-icon fontSet="material-symbols-outlined"> cancel </mat-icon>
                                </button>
                                <button
                                    mat-icon-button
                                    class="st-cast-list-accordion-pane-container-action"
                                    st-click-stop-propagation
                                    [disabled]="isReadonly || isSectionInEditMode(node?.id)"
                                    (click)="deleteSection($event, node?.id)">
                                    <mat-icon fontSet="material-symbols-outlined"> delete </mat-icon>
                                </button>

                                <button
                                    mat-icon-button
                                    class="st-cast-list-accordion-pane-container-expand-collapse"
                                    st-click-stop-propagation
                                    [matTooltip]="treeControl.isExpanded(node) ? collapseAllLabel : expandAllLabel"
                                    (click)="expandCollapseAll(node)">
                                    <mat-icon fontSet="material-symbols-outlined"> {{ treeControl.isExpanded(node) ? 'collapse_all' : 'expand_all' }} </mat-icon>
                                </button>
                            </ng-container>
                        </st-expansion-panel>
                    </ng-template>
                    <ng-template ngSwitchDefault>
                        <st-cast-item
                            cdkDrag
                            [cdkDragDisabled]="isReadonly || castService.isCreatePublicationPending"
                            [dragStarted]="castService.dragStarted"
                            [publication]="node?.object"
                            [isReadOnly]="isReadonly || castService.isCreatePublicationPending"
                            [lastInGroup]="node?.nodeLastInGroup"
                            [firstInGroup]="node?.nodeFirstInGroup"
                            [shouldShowCustomFields]="shouldShowCustomFields"
                            (cdkDragStarted)="onDragStarted($event, node.id)"
                            (cdkDragEnded)="onDragEnded()"
                            (dragEnterEmitter)="onDragEnter($event)"
                            (deletePublicationEmitter)="deletePublication($event)">
                            <div
                                *cdkDragPreview
                                class="st-cast-item-drag-preview">
                                <st-cast-item
                                    *ngIf="draggedObject"
                                    [publication]="draggedObject" />
                            </div>
                        </st-cast-item>
                    </ng-template>
                </ng-container>
            </ng-container>
        </cdk-virtual-scroll-viewport>
    </st-accordion>
</ng-template>

<ng-template #mainCta>
    <ng-container>
        <mat-button-toggle-group class="st-cast-list-main-cta-button-group">
            <mat-button-toggle
                class="st-cast-list-button-new-topic"
                [class.st-cast-list-button-new-topic__disabled]="!topicEditable"
                [disabled]="!topicEditable"
                (click)="onNewTopicOpened()">
                <mat-icon class="material-symbols-outlined"> add </mat-icon>
                {{ languageSettings.PSTWebNewLabel }}
            </mat-button-toggle>
            <mat-button-toggle
                class="st-cast-list-button-new-topic-template"
                [class.st-cast-list-button-new-topic-template__disabled]="!topicEditable"
                [matMenuTriggerFor]="templateMenu"
                [disabled]="topicTemplatesDisabled"
                (menuOpened)="onMenuOpened()">
                <mat-icon> arrow_drop_down </mat-icon>
                {{ languageSettings.PSTWebTemplateLabel }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </ng-container>
</ng-template>

<mat-menu #templateMenu="matMenu">
    <ng-template [ngIf]="topicTemplates.length > 0">
        <ng-template
            let-item
            let-i="index"
            ngFor
            [ngForOf]="topicTemplates">
            <mat-selection-list
                hideSingleSelectionIndicator
                [multiple]="false">
                <mat-list-option
                    st-click-stop-propagation
                    [value]="item?.Title"
                    [dir]="isRTL"
                    (click)="openNewTopicFromTemplateDialog(item)">
                    <div
                        matListItemTitle
                        class="st-cast-list-button-new-topic-template__title">
                        <span> {{ item?.Title }} </span>
                        <button
                            mat-icon-button
                            matListItemMeta
                            st-click-stop-propagation
                            (click)="deleteTemplate(item, topicTemplates, i)">
                            <mat-icon> delete </mat-icon>
                        </button>
                    </div>
                </mat-list-option>
            </mat-selection-list>
        </ng-template>
    </ng-template>
</mat-menu>

<ng-template #secondaryCta>
    <button
        mat-icon-button
        class="st-cast-list-secondary-cta-button-save-as"
        [matTooltip]="languageSettings.PSTWebSaveViewSettings"
        [matMenuTriggerFor]="menu">
        <mat-icon class="material-symbols-outlined"> save_as </mat-icon>
    </button>
    <button
        mat-icon-button
        class="st-cast-list-secondary-cta-button-one"
        [matTooltip]="languageSettings.PSTWebCustomizeTopicCard"
        (click)="openTopicCardCustomFieldsDialog()">
        <mat-icon class="material-symbols-outlined"> rule </mat-icon>
    </button>
    <mat-menu
        #menu="matMenu"
        class="st-playbook-list-secondary-cta-menu">
        <button
            *ngIf="saveViewSettingsEnabled"
            mat-menu-item
            (click)="saveViewState()">
            {{ languageSettings.PSTWebSaveViewSettings }}
        </button>
        <button
            *ngIf="saveAsViewSettingsEnabled"
            mat-menu-item
            (click)="saveAsViewState()">
            {{ languageSettings.PSTWebSaveAsViewSettings }}
        </button>
    </mat-menu>
</ng-template>

<ng-template #viewOptions>
    <ng-container *ngrxLet="viewStateLayoutOptions$ as viewStateLayoutOptions">
        <st-list-drop-down
            class="st-cast-list-view-options"
            labelPosition="after"
            [value]="viewStateLayoutValue$ | ngrxPush"
            [label]="languageSettings?.PSTWebViewLabel"
            [list]="viewStateLayoutOptions.Options"
            (valueOutput)="updateLayout($event)" />
    </ng-container>
</ng-template>
<ng-template #rightSlot>
    <st-date-range-pager
        #dateRangePager
        datePickerEnabled
        [isEnabled]="!inEditMode"
        [dayCount]="1"
        (previousEmitter)="load($event.firstDay.get())"
        (nextEmitter)="load($event.firstDay.get())" />
</ng-template> -->

<!-- (cdkDropListDropped)="onPublicationListSectionsDrop()"> -->

@if (listLoading()) {
    <st-loader
        class="st-cast-list-loader"
        [diameter]="200"
        [productLabel]="languageSettings.PSTWebLoadingLabel"
        [strokeWidth]="10" />
} @else {
    <mat-toolbar class="st-cast-list-second-top-bar">
        <mat-toolbar-row class="st-cast-list-second-top-bar-row">
            <div class="st-cast-list-second-top-bar-main-cta">
                <mat-label class="st-cast-list-label-channel">{{ channel()?.Title }}{{ editionName() ? ':' + editionName() : '' }} </mat-label>
                <mat-label class="st-cast-list-label-published">{{ publicationStatusLabel() }} </mat-label>
            </div>
            <div class="st-cast-list-second-top-bar-right-slot">
                <st-list-drop-down
                    labelPosition="before"
                    [label]="languageSettings.PSTWebRevisionsLabel"
                    [value]="publicationRevisionNumber()"
                    [list]="publicationRevisionsList()"
                    (valueOutput)="updateRevisionNumber($event)" />
                @if (isReadonly() && !inEditMode()) {
                    <button
                        type="button"
                        class="st-cast-list-button st-cast-list-top-bar-right-slot-button-light"
                        [disabled]="disabledCreateNewRevisionButton()"
                        [class.st-cast-list-button-disabled]="disabledCreateNewRevisionButton()"
                        (click)="newRevision()">
                        {{ languageSettings.PSTWebCreateNewRevisionLabel }}
                    </button>
                } @else {
                    <button
                        type="button"
                        class="st-cast-list-button st-cast-list-button-right-slot-light"
                        [class.st-cast-list-button-disabled]="disabledPublishButton()"
                        [disabled]="disabledPublishButton()"
                        (click)="publish()">
                        {{ languageSettings.PSTWebPublishLabel }}
                    </button>
                }
                <button
                    type="button"
                    class="st-cast-list-button st-cast-list-button-right-slot-transparent"
                    [disabled]="disabledPublishButton()"
                    [class.st-cast-list-button-disabled]="disabledPublishButton()"
                    (click)="removeAll()">
                    {{ languageSettings.PSTWebClearAllItemsLabel }}
                </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    <st-accordion
        class="st-cast-list-accordion"
        cdkDropListGroup>
        <cdk-virtual-scroll-viewport
            id="publication-list-sections"
            class="st-cast-list-view-port"
            st-different-sizes
            cdkScrollable
            cdkDropList
            sortingDisabled
            [itemHeights]="cardItemHeights()"
            (cdkDropListDropped)="onPublicationListSectionsDrop($event)">
            <ng-container *cdkVirtualFor="let node of dataSource(); let isLast = last; let idx = index; trackBy: trackByGuid">
                @switch (node?.level) {
                    @case (0) {
                        <st-expansion-panel
                            droppable
                            class="st-cast-list-accordion-pane-container"
                            [guid]="node?.id"
                            [dragEnabled]="true"
                            [dragStarted]="selectIsDragStarted()"
                            [expanded]="treeControl().isExpanded(node)"
                            (dragEnterEmitter)="onDragEnter(node, true)"
                            (click)="toggleNode(node)">
                            <ng-container title>
                                @if (editedSections().has(node?.id)) {
                                    <st-text-field
                                        class="st-cast-list-accordion-pane-container-section"
                                        st-click-stop-propagation
                                        [value]="editedSections().get(node?.id)"
                                        (keydown.Space)="$event.stopPropagation()"
                                        (keydown.Backspace)="$event.stopPropagation()"
                                        (changed)="onSectionNameChanged($event, node?.id)" />
                                } @else {
                                    <span class="st-cast-list-accordion-pane-container-label">{{ node?.label }}</span>
                                }
                            </ng-container>
                            <ng-container
                                actions
                                class="st-cast-list-accordion-pane-container-actions"
                                st-click-stop-propagation>
                                <span class="st-cast-list-accordion-pane-container-count"> {{ node?.itemsCount }} {{ languageSettings?.PSTWebPublicationItemsLabel || '' }} </span>
                                @if (editedSections().has(node?.id)) {
                                    <button
                                        mat-icon-button
                                        class="st-cast-list-accordion-pane-container-first"
                                        st-click-stop-propagation
                                        [disabled]="isReadonly()"
                                        (click)="saveEditSection(node?.id, node?.index)">
                                        <mat-icon fontSet="material-symbols-outlined"> save </mat-icon>
                                    </button>

                                    <button
                                        mat-icon-button
                                        class="st-cast-list-accordion-pane-container-action"
                                        st-click-stop-propagation
                                        [disabled]="isReadonly() && !editedSections().has(node?.id)"
                                        (click)="cancelEditSection(node?.id)">
                                        <mat-icon fontSet="material-symbols-outlined"> cancel </mat-icon>
                                    </button>
                                } @else {
                                    <button
                                        mat-icon-button
                                        class="st-cast-list-accordion-pane-container-first"
                                        st-click-stop-propagation
                                        [disabled]="isReadonly()"
                                        (click)="addSection(node?.index)">
                                        <mat-icon fontSet="material-symbols-outlined"> add </mat-icon>
                                    </button>
                                    <button
                                        mat-icon-button
                                        class="st-cast-list-accordion-pane-container-action"
                                        st-click-stop-propagation
                                        [disabled]="isReadonly()"
                                        (click)="editSection(node?.id)">
                                        <mat-icon fontSet="material-symbols-outlined"> edit </mat-icon>
                                    </button>
                                }
                                <button
                                    mat-icon-button
                                    class="st-cast-list-accordion-pane-container-action"
                                    st-click-stop-propagation
                                    [disabled]="isReadonly() || !hasMoreThanOneSection() || editedSections().has(node?.id)"
                                    (click)="deleteSection($event, node?.id)">
                                    <mat-icon fontSet="material-symbols-outlined"> delete </mat-icon>
                                </button>

                                <button
                                    mat-icon-button
                                    class="st-cast-list-accordion-pane-container-expand-collapse"
                                    st-click-stop-propagation
                                    [matTooltip]="treeControl().isExpanded(node) ? languageSettings?.PSTWebCollapseAllLabel : languageSettings?.PSTWebExpandAllLabel"
                                    (click)="expandCollapseAll(node)">
                                    <mat-icon fontSet="material-symbols-outlined"> {{ treeControl().isExpanded(node) ? 'collapse_all' : 'expand_all' }} </mat-icon>
                                </button>
                            </ng-container>
                        </st-expansion-panel>
                    }

                    @default {
                        <st-cast-item
                            cdkDrag
                            [cdkDragDisabled]="isReadonly() || isProcessing()"
                            [publication]="node?.object"
                            [isReadOnly]="isReadonly() || isProcessing()"
                            [lastInGroup]="node?.nodeLastInGroup"
                            [firstInGroup]="node?.nodeFirstInGroup"
                            [shouldShowCustomFields]="shouldShowCustomFields()"
                            [dragStarted]="selectIsDragStarted()"
                            (cdkDragStarted)="onDragStarted(node)"
                            (cdkDragEnded)="onDragEnded()"
                            (dragEnterEmitter)="onDragEnter(node)"
                            (deletePublicationEmitter)="deletePublication($event)"
                            (openFullscreenHandler)="onFullscreenHandler(node)">
                            <div
                                *cdkDragPreview
                                class="st-cast-item-drag-preview">
                                @if (draggedObject()) {
                                    <st-cast-item [publication]="draggedObject()" />
                                }
                            </div>
                        </st-cast-item>
                    }
                }
            </ng-container>
        </cdk-virtual-scroll-viewport>
    </st-accordion>
}

<ng-template #secondaryCta>
    <button
        mat-icon-button
        class="st-cast-list-secondary-cta-button-save-as"
        [matTooltip]="languageSettings.PSTWebSaveViewSettings"
        [matMenuTriggerFor]="menu">
        <mat-icon class="material-symbols-outlined"> save_as </mat-icon>
    </button>
    <button
        mat-icon-button
        class="st-cast-list-secondary-cta-button-one"
        [matTooltip]="languageSettings.PSTWebCustomizeTopicCard"
        (click)="openTopicCardCustomFieldsDialog()">
        <mat-icon class="material-symbols-outlined"> rule </mat-icon>
    </button>
    <mat-menu
        #menu="matMenu"
        class="st-playbook-list-secondary-cta-menu">
        @if (saveViewSettingsEnabled()) {
            <button
                mat-menu-item
                (click)="saveViewState()">
                {{ languageSettings.PSTWebSaveViewSettings }}
            </button>
        }

        @if (saveAsViewSettingsEnabled()) {
            <button
                mat-menu-item
                (click)="saveAsViewState()">
                {{ languageSettings.PSTWebSaveAsViewSettings }}
            </button>
        }
    </mat-menu>
</ng-template>
<ng-template #viewOptions>
    <st-list-drop-down
        class="st-cast-list-view-options"
        labelPosition="after"
        [value]="viewStateLayoutValue()"
        [label]="languageSettings?.PSTWebViewLabel"
        [list]="viewStateLayoutOptions().Options"
        (valueOutput)="updateLayout($event)" />
</ng-template>
<ng-template #rightSlot>
    <st-date-range-pager
        #dateRangePager
        datePickerEnabled
        [period]="currentPeriod()"
        [dayCount]="1" />
</ng-template>

<ng-template #mainCta>
    <mat-button-toggle-group class="st-cast-list-main-cta-button-group">
        <mat-button-toggle
            class="st-cast-list-button-new-topic"
            [class.st-cast-list-button-new-topic__disabled]="!topicEditable"
            [disabled]="!topicEditable"
            (click)="onNewTopicClicked()">
            <mat-icon class="material-symbols-outlined"> add </mat-icon>
            {{ languageSettings.PSTObjectTypeTopic }}
        </mat-button-toggle>
        <mat-button-toggle
            mat-icon-button
            class="st-cast-list-button-new-topic-template"
            [class.st-cast-list-button-new-topic-template__disabled]="!topicEditable"
            [matMenuTriggerFor]="topicTemplateMenu"
            [disabled]="topicTemplatesDisabled()"
            (menuOpened)="onTopicTemplateMenuOpened()">
            <mat-icon> arrow_drop_down </mat-icon>
        </mat-button-toggle>
    </mat-button-toggle-group>
</ng-template>

<mat-menu
    #topicTemplateMenu="matMenu"
    class="st-cast-list-templates-menu">
    <ng-template [ngIf]="topicTemplates().length > 0">
        <ng-template
            let-item
            let-i="index"
            ngFor
            [ngForOf]="topicTemplates()">
            <mat-selection-list
                hideSingleSelectionIndicator
                [multiple]="false">
                <mat-list-option
                    st-click-stop-propagation
                    [value]="item?.Title"
                    (click)="selectTopicTemplate(item)">
                    <div
                        matListItemTitle
                        class="st-cast-list-button-new-topic-template__title"
                        [dir]="isRTL()">
                        <span> {{ item?.Title }} </span>
                        <button
                            mat-icon-button
                            matListItemMeta
                            st-click-stop-propagation
                            class="st-cast-list-button-new-topic-template__delete-button"
                            (click)="deleteTemplate(item)">
                            <mat-icon> delete </mat-icon>
                        </button>
                    </div>
                </mat-list-option>
            </mat-selection-list>
        </ng-template>
    </ng-template>
</mat-menu>
